function CartDetailHandler(product = "", event = "", data = {}) {
  const {
    metaData = {},
    setData: {
      tripInfos = [],
      cartInfo: { status = "", amount = "", bookingId = "" } = {},
    } = {},
  } = data;
  const { userId: Identity } = metaData;
  const baseEventProperties = {
    Identity,
  };

  const tripInfo = getTripInfo(tripInfos || []);

  switch (event) {
    case "TransitVisa": {
      return {
        ...baseEventProperties,
        ...tripInfo,
        status,
        grossFare: amount,
        bookingId,
      };
    }
    default:
      return {};
  }
}

module.exports = {
  CartDetailHandler,
};

function getTripInfo(trips = []) {
  const { depCity: departureCity = "", depInfo: depatureInfo = "" } =
    trips[0] || {};
  const { arrCity: arrivalCity = "", arrInfo: arrivalInfo = "" } =
    trips[trips.length - 1] || {};

  const { country: depatureCountry = "", code: depatureAirportCode = "" } =
    extractAirportInfo(depatureInfo);
  const { country: arrivalCountry = "", code: arrivalAirportCode = "" } =
    extractAirportInfo(arrivalInfo);

  const sourceNameSet = new Set();
  const fareTypeSet = new Set();
  const cabinClassSet = new Set();

  trips.forEach(({ tripInfo = [] }) => {
    tripInfo.forEach(
      ({
        priority: { sN = "" } = {},
        static: { fareType = "" } = {},
        nonPriority: { cc = "" } = {},
      }) => {
        sourceNameSet.add(sN);
        fareTypeSet.add(fareType);
        cabinClassSet.add(cc);
      }
    );
  });

  return {
    originCity: departureCity,
    originCountry: depatureCountry,
    originCode: depatureAirportCode,
    destinationCity: arrivalCity,
    destinationCountry: arrivalCountry,
    destinationCode: arrivalAirportCode,
    supplier: Array.from(sourceNameSet).join(", "),
    fareType: Array.from(fareTypeSet).join(", "),
    cabinClass: Array.from(cabinClassSet).join(", "),
  };
}

function extractAirportInfo(inputString) {
  const regexPattern = /^([\w\s]+) \(([\w\s]+)\) - (\w+)$/;
  const matchResult = inputString.match(regexPattern);

  if (matchResult) {
    const countryName = matchResult[1];
    const airportName = matchResult[2];
    const airportCode = matchResult[3];
    return {
      country: countryName,
      name: airportName,
      code: airportCode,
    };
  } else {
    return {};
  }
}
